

window.addEventListener('DOMContentLoaded', () => {
    const elNavigation = document.querySelector('.menu-content')
    const elBurger = document.querySelector('.burger-menu')
    const elHeader = document.querySelector('.block-header')


// menu mobile
    elBurger.addEventListener('click', () => {
        elNavigation.classList.toggle('menu-open')
        elBurger.classList.toggle('menu-open')
        elHeader.classList.toggle('menu-open')
    })

    // header scroll
    const elJSHeader = document.querySelector('.block-header')

    window.addEventListener('scroll', () => {

        if(window.scrollY == 0) {

            elHeader.classList.remove('scrolled')
            if(!elJSHeader) {
                elHeader.classList.remove('fixed')
            }

        } else {

            elHeader.classList.add('scrolled')

            if(elJSHeader) {

                if(window.scrollY >= (elJSHeader.getBoundingClientRect().height - 120)) {
                    elHeader.classList.add('fixed')
                } else {
                    elHeader.classList.remove('fixed')
                }

            } else {
                elHeader.classList.add('fixed')
            }

        }

    })
})


